import axios from 'axios';

export default axios.create({
    baseURL: 'https://dtedesignathon-backend.vercel.app'
})